export default function PopmenuIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="240"
      height="240"
      version="1"
      viewBox="0 0 180 180"
      fill="#E54548FF"
    >
      <path
        d="M710 1780c-61-11-171-54-236-91-170-97-299-264-354-460-103-365 92-764 444-906l81-32 5-143c4-102 8-138 15-126 6 9 28 36 50 60s66 73 97 109c56 64 60 67 115 74 201 25 396 124 503 255 25 30 39 40 53 36 101-26 219 191 186 342-22 103-85 134-148 71-40-39-94-137-121-218-19-57-20-70-9-109l12-43-49-51c-122-125-305-208-459-208-53 0-54-1-106-60-28-33-56-57-60-54-5 3-9 32-9 64v59l-57 16c-228 66-407 251-473 487-25 91-27 252-4 342 41 163 160 328 301 416 294 186 680 127 898-138 53-64 66-94 45-107-15-10-12-107 6-156 8-24 18-74 21-111 4-48 10-68 19-68 21 0 18 82-6 168-24 87-25 130-4 160 40 58 118 42 155-30 24-48 58-196 59-255 0-32 4-43 15-43 20 0 20 57 0 158-31 154-87 242-155 242-21 0-35 9-51 33-63 89-172 185-273 241-102 56-190 78-331 82-71 1-150-1-175-6z"
        transform="matrix(.1 0 0 -.1 0 180)"
      ></path>
      <path
        d="M389 1329c-8-16-8-28 0-45l11-24h443c466 0 467 0 467 45s-1 45-467 45c-441 0-442 0-454-21zM1564 1264c15-37 36-150 36-191 0-33 4-43 16-43 15 0 16 9 11 73-9 105-28 171-51 175-15 3-17 0-12-14zM1500 1248c1-7 7-40 15-73s15-79 15-102c0-32 4-43 15-43s15 12 15 46c0 68-29 184-46 184-8 0-14-6-14-12zM400 1080c-25-25-25-42-2-63 17-15 62-17 446-17 275 0 434 4 447 10 23 13 25 53 3 74-14 14-68 16-445 16-416 0-430-1-449-20zM397 822c-22-24-21-38 3-62 19-19 33-20 443-20 366 0 426 2 445 16 27 19 29 60 3 74-13 6-172 10-449 10-403 0-430-1-445-18z"
        transform="matrix(.1 0 0 -.1 0 180)"
      ></path>
    </svg>
  );
}
